import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'new-export-dropdown',
  templateUrl: './new-export-dropdown.component.html',
  styleUrls: ['./new-export-dropdown.component.css'],
  
})
export class NewExportDropdownComponent implements OnInit {
  @Output() onSelectionChange: EventEmitter<void> = new EventEmitter<void>();
   @Input() ifGridHaveCheckBox: boolean;
   @Input() classForExportDropdownButton: any;
   @Input() disabled: boolean;
 
   constructor() { }
 
   ngOnInit(): void {
   } exportGrid(value: any) {
     // If trying to export selected rows (value 2 or 4) but no rows are selected, don't proceed
     if ((value === 2 || value === 4) && !this.ifGridHaveCheckBox) {
       return;
     }
     this.onSelectionChange.emit(value);
   }
}
